export const SUPPORT_ADMIN_ALERT_EVENT = 'support-admin-alert';
export const SUPPORT_NOTIFICATION_REFRESH_EVENT = 'support-notification-refresh';
